export default "__VITE_ASSET__DvcpARMg__"